// apps/web/src/lib/supabase.ts

import { createClient } from '@supabase/supabase-js'
import type { Database } from '../types/database'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL!
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY!

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
})

// Type-safe database operations
export type Tables = Database['public']['Tables']
export type Note = Tables['notes']['Row']
export type NoteInsert = Tables['notes']['Insert']
export type NoteUpdate = Tables['notes']['Update']
export type Tag = Tables['tags']['Row']
export type TagInsert = Tables['tags']['Insert']
export type TagUpdate = Tables['tags']['Update']
export type UserPreferences = Tables['user_preferences']['Row']
